import React, { useState } from 'react'
import { prepareData } from 'utils/googleData'
import { CallToAction } from 'components/CallToAction'
import { useUser } from 'hooks/useUser'
import { navigate } from 'gatsby'
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next'
import { Spacer } from '../Spacer'
import { CalendlyEventListener, EventScheduledEvent, InlineWidget } from 'react-calendly'
import useiCloudReady from 'hooks/useiCloudReady'
import tracking from 'utils/analytics'

export const DemoScheduler = ({
    iframeSrc = 'https://calendly.com/icloudready/icloudready-30-minute-quick-chat',
    type = 'scale',
}: {
    iframeSrc?: string
    type?: string
}): JSX.Element => {
    const { user = {}, fetchUser, isLoading, getJwt } = useUser()
    const icloudready = useiCloudReady()
    const calendlyEventScheduled = (e: EventScheduledEvent) => {
        const { event, payload = null } = e.data
        icloudready?.capture(event, {
            calendly_event_uri: payload?.event.uri,
            calendly_invitee_uri: payload?.invitee.uri,
            demo_type: type,
        })
        tracking.trackConversion(
            'request_meeting',
            {
                calendly_event_uri: payload?.event.uri,
                calendly_invitee_uri: payload?.invitee.uri,
                demo_type: type,
            },
            user
        )
        tracking.eventTrack('interaction', 'request_meeting', 'request_discovery')
    }

    return (
        <>
            <div className="w-full overflow-hidden rounded-lg">
                <CalendlyEventListener onEventScheduled={calendlyEventScheduled}>
                    <InlineWidget
                        url={iframeSrc}
                        styles={{
                            height: '900px',
                            minWidth: '320px',
                            width: '100%',
                        }}
                    />
                </CalendlyEventListener>
            </div>
            <Spacer height={60} />
        </>
    )
}

// export function DemoScheduler2(props = {}) {
//     const result = prepareData({ props })
//     const { user = {}, fetchUser, isLoading, getJwt } = useUser()
//     const {
//         direction,
//         enable,
//         description,
//         text,
//         style,
//         gatsbyImage,
//         contact_us,
//         book_your_free_demo,
//         title,
//         subtitle,
//         hintText,
//         bookText,
//     } = result
//     const type = result?.type || 'scale'
//     const iframeSrc = result?.iframeSrc || 'https://calendly.com/icloudready/request-discovery'
//     if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
//         return <></>
//     }
//     const icloudready = useiCloudReady()
//     const calendlyEventScheduled = (e: EventScheduledEvent) => {
//         const { event, payload = null } = e.data
//         icloudready?.capture(event, {
//             calendly_event_uri: payload?.event.uri,
//             calendly_invitee_uri: payload?.invitee.uri,
//             demo_type: type,
//         })
//         tracking.trackConversion(
//             'request_meeting',
//             {
//                 calendly_event_uri: payload?.event.uri,
//                 calendly_invitee_uri: payload?.invitee.uri,
//                 demo_type: type,
//             },
//             user
//         )
//         tracking.eventTrack('interaction', 'request_meeting', 'request_discovery')
//     }
//     const [show, setShow] = useState(false)

//     const handleClose = () => setShow(false)

//     const handleShow = () => {
//         setShow(true)
//     }

//     return (
//         <>
//             <h2>{contact_us}</h2>
//             <h1>{book_your_free_demo}</h1>
//             <div className="contact-Jumbotron">
//                 <div className="contact-header">
//                     <h4>{title}</h4>
//                     <h5>{subtitle}</h5>
//                 </div>
//                 <p className="contact-hint">{hintText}</p>
//                 <CallToAction onClick={handleShow}>{bookText}</CallToAction>
//                 <CalendlyEventListener onEventScheduled={calendlyEventScheduled}>
//                     <PopupModal
//                         url={iframeSrc}
//                         open={show}
//                         onModalClose={handleClose}
//                         rootElement={typeof window !== 'undefined' ? window.document.body : null}
//                     />
//                 </CalendlyEventListener>
//             </div>
//             <Spacer height={100} />
//         </>
//     )
// }
